/*
<template>
	<!-- 계측기/공구/기타 장비 -->
	<div class="w-100">
		{{ getMessage_('QWCC002063') }}
		<sf-card class="w-100 h-100 pt-3">
			<bar-chart :height="277" ref="grpBar" :chartData="dataCollection" :options="options" />
		</sf-card>
	</div>
</template>

<script>
import Chart from '@/qmsUtils/chartModule';
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../store/helpers';
export default {
	components: {
		BarChart: Chart.BarChart
	},
	created() {
		this.options.scales.yAxes[0].ticks.suggestedMax = this.sumCnt * 1.1;
	},
	data() {
		return {
			options: {
				indexAxis: 'y',
				responsive: true,
				maintainAspectRatio: false, // chart 높이 지정을 위해 필요
				legend: {
					display: false,
					position: 'bottom' //범례 위치: 아래
				},
				plugins: {
					datalabels: {
						color: '#000', //데이터 값 표시 폰트 색상
						anchor: 'end'
					}
				},
				scales: {
					xAxes: [
						{
							stacked: false
						}
					],
					yAxes: [
						{
							stacked: false,
							ticks: {
								beginAtZero: true,
								suggestedMax: 100,
								suggestedMin: 0
							}
						}
					]
				}
			}
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		dataCollection() {
			//그래프 맥스값 지정
			return {
				labels: this.sumLabel_,
				datasets: this.sumDataSet_
			};
		}
	}, //end cu
	methods: {
		...serviceMethods
	}
};
</script>

<style></style>
